import { render } from "./markAsReadButton.vue?vue&type=template&id=0ac91c48"
import script from "./markAsReadButton.vue?vue&type=script&lang=js"
export * from "./markAsReadButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__